// extracted by mini-css-extract-plugin
module.exports = {"Testimonials":"Testimonials_Testimonials__19v76","Dot":"Testimonials_Dot__9iFyc","active":"Testimonials_active__d8ioF","Controller":"Testimonials_Controller__3sW7V"};